import { useContext, useEffect } from 'react'
import { getNotes } from 'services/research'
import { Context as AffiliationNoteContext } from '../contexts/AffiliationNoteContext'

import useSearchInputRead from '../hooks/useSearchInputRead'

function useAffiliationNotes() {
  const { affiliatedId } = useSearchInputRead()

  const context = useContext(AffiliationNoteContext)
  if (!context) {
    throw new Error(`useAffiliationNotes must be used within a AffiliationNoteContext`)
  }
  const [state, dispatch] = context

  useEffect(() => {
    const fetchAffiliationNotes = async ({ affiliatedId }) => {
      try {
        const options = {
          notable_id: affiliatedId,
          page_offset: state.page * state.rowsPerPage, // Need to start at 0 to support @material-ui pagination
          page_size: Number(state.rowsPerPage),
        }
        dispatch({ type: 'AFFILIATION_NOTE:FETCH_STARTED' })
        const {
          data,
          total,
          links: { self, next, prev },
        } = await getNotes(options)
        dispatch({
          type: 'AFFILIATION_NOTE:FETCH_RECEIVED',
          payload: {
            notes: data,
            total: total,
            self: self,
            next: next,
            prev: prev,
            page: state.page,
            rowsPerPage: state.rowsPerPage,
          },
        })
      } catch (error) {
        dispatch({ type: 'AFFILIATION_NOTE:FAILED', payload: error })
      }
    }

    if (affiliatedId) {
      fetchAffiliationNotes({ affiliatedId })
    }
  }, [dispatch, affiliatedId, state.page, state.rowsPerPage])

  const setPage = page => {
    dispatch({ type: 'AFFILIATION_NOTE:SET_PAGE', payload: { page } })
  }

  const setRowsPerPage = ({ page, rowsPerPage }) => {
    dispatch({ type: 'AFFILIATION_NOTE:SET_ROWS_PER_PAGE', payload: { page, rowsPerPage } })
  }

  const handlePage = newPage => {
    const page = state.page
    if (newPage > page && newPage < state.total) {
      setPage(page + 1)
    } else if (newPage < page) {
      setPage(page - 1)
    }
  }

  return {
    state,
    setPage: handlePage,
    setRowsPerPage,
  }
}

export default useAffiliationNotes
